<div [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="gasket_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Gasket -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.GASKET' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #gasket_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.GASKET' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <div class="mat-select input-select" (click)="open(mymodaltree)" [ngClass]="tempGasketValue ? '' : 'highLight'" [class.disable-div]="enable">
        <div cdk-overlay-origin="" class="mat-select-trigger">
            <div class="mat-select-value">
                <span class="mat-select-min-line">{{ tempGasketValue }}</span>
            </div>
            <div class="mat-select-arrow-wrapper">
                <div class="mat-select-arrow"><mat-icon>arrow_drop_down</mat-icon></div>
            </div>
        </div>
    </div>

    <ng-template #mymodaltree let-modal>
        <div class="modal-header">
            <h4 style="align-items: flex-start">
                <!-- Select Gasket -->
                <ng-container *transloco="let t; read: 'STANDARD_FLANGE_PAGE.LABELS'"> {{ t('SELECT') }} {{ t('CALC_INPUT.GASKET') }} </ng-container>
            </h4>
            <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="closeModal()" style="top: 10px"><i class="flaticon2-cross"></i></a>
        </div>
        <div class="modal-body scroll-table">
            <ng-container *ngIf="this.gasketnodeList?.length; else noDataTemplate">
                <mat-tree [dataSource]="treedataSource" [treeControl]="treeControl" class="tree_button">
                    <!--This is the tree node template for leaf nodes-->
                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [class.selectedGasket]="selectedGasketResp == node.id">
                        <!--use a disabled button to provide padding for tree leaf-->
                        <button mat-button (click)="selectedGasket(node)">
                            {{ node?.alias ? node.alias + ' - ' : '' }}
                            {{ node.name }}
                        </button>
                    </mat-tree-node>
                    <!--This is the tree node template for expandable nodes-->
                    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding class="active">
                        <button (click)="toggleOthers(node)" mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>
                        {{ node?.alias ? node.alias + ' - ' : '' }}
                        {{ node.name }}
                    </mat-tree-node>
                </mat-tree>
            </ng-container>
        </div>
    </ng-template>
</div>

<ng-template #noDataTemplate>
    <div class="no-data">
        <h4>No data available to display. Please contact system administrator.</h4>
    </div>
</ng-template>
